import React from 'react';
import BannerSites from '../../../components/Campanhas/BannerSites';
import SiteBox from '../../../components/Campanhas/SiteBox';
import AdvantageSite from '../../../components/Campanhas/AdvantagesBox';
import Interest from '../../../components/Campanhas/Interest';
import SitesModelsList from '../../../components/Campanhas/SitesModelsList';

const WithoutSites = () => (
	<>
		<BannerSites hasProduct />
		<SiteBox />
		<AdvantageSite />
		<SitesModelsList />
		<Interest />
	</>
    );
export default WithoutSites;
